<section class="title-holder">
    <div class="container p-4">
        <div class="row">
            <h2 class="text-center w-100">Blogs</h2>
        </div>
    </div>
</section>
<div class="blog container" *ngIf="featuredBlog">
    <div class="row w-100 px-3 pt-4 mt-2">
        <h3>Featured Blog</h3>
    </div>

    <div class="blog-card">
        <div class="meta">
          <div class="photo" [style.background]="featuredBlog.backgroundImageURL"></div>
          <ul class="details">
            <li class="date"><i class="fas fa-clock"></i> {{ featuredBlog.publishedDate }}</li>
          </ul>
        </div>
        <div class="description">
            <a [routerLink]="['/blog/'+featuredBlog.slug]">
                <h1 class="pb-2">{{ featuredBlog.title }}</h1>
                <h2 class="pb-1">By: {{ featuredBlog.authorName }}</h2>
                <p class="pt-2"> {{ featuredBlog.excerpt }}</p>
                <p class="read-more">
                    <strong>Read More</strong>
                </p>    
            </a>
        </div>
    </div>
    <hr class="mt-5" />

    <section id="all-blogs" class="top pt-3">
        <div class="container">
            <div class="row">
                <div class="form-group ml-3">
                    <label class="mr-2">Sort from:</label>
                    <select [(ngModel)]="selectedDate" (ngModelChange)="getBlogs()">
                        <option value="new">Newest to Oldest</option>
                        <option value="old">Oldest to Newest</option>
                    </select>
                </div>
            </div>
            <div class="container" *ngIf="loading">
                <div class="row justify-content-center mt-5 mb-5">
                    <mat-spinner [diameter]="'70'" [color]="'warn'"></mat-spinner>
                </div>
            </div>
            <!-- note: limit word count to 20 -->
            <div class="row" *ngIf="blogList.length > 0">
                <div class="col-md-6 col-sm-12 col-lg-4" *ngFor="let blog of blogList">
                    <a class="d-block h-100" [routerLink]="['/blog/'+blog.slug]">
                        <div class="card">
                            <img [src]="blog.featuredImage">
                            <div class="p-2">
                                <div class="date">{{ blog.publishedDate }}</div>
                                <h4>{{ blog.title }}</h4>
                                <small class="strong pb-3">{{ blog.minRead }}</small>
                                <p class="excerpt text-justify pt-3">{{ blog.excerpt }}</p>
                            </div>
                        </div>
                    </a>
                </div>
            </div>
            <div class="row mt-5 mb-5 justify-content-center" *ngIf="blogList.length == 0">
                <h3 class="info-text text-center">There are currently no Blogs posted by the site admin. Please check back later.</h3>
            </div>
            <div class="row ml-auto mr-auto mt-5 mb-5 justify-content-center" *ngIf="blogList.length > 0">
                <div class="arrow-holders">
                    <button mat-button (click)="firstPage()" [disabled]="page == 1">
                        <mat-icon>first_page</mat-icon>
                    </button>
                    <button mat-button (click)="previousPage()" [disabled]="page == 1">
                        <mat-icon>chevron_left</mat-icon>
                    </button>
                    <button mat-button disabled>
                        {{ page }} of {{ lastpage }}
                    </button>
                    <button mat-button (click)="nextPage()" [disabled]="page == lastpage">
                        <mat-icon>chevron_right</mat-icon>
                    </button>
                    <button mat-button (click)="lastPage()" [disabled]="page == lastpage">
                        <mat-icon>last_page</mat-icon>
                    </button>
                </div>
            </div>
        </div>
    </section>

</div>
<div class="container" *ngIf="firstLoading">
    <div class="row justify-content-center mt-5 mb-5">
        <mat-spinner [diameter]="'70'" [color]="'warn'"></mat-spinner>
    </div>
</div>
<div class="container" *ngIf="!featuredBlog">
    <div class="row mt-5 mb-5 justify-content-center" *ngIf="blogList.length == 0">
        <h3 class="info-text text-center">There are currently no Blogs posted by the site admin. Please check back later.</h3>
    </div>
</div>